module.exports = __webpack_public_path__ + "img/logo.fc715bc0.png";